/*
 * Entry point for the montana app
 */
import 'vite/modulepreload-polyfill';
import 'core-js/features/promise';
import 'regenerator-runtime/runtime';
import './legacy/scss/bootstrap_custom.scss';

import { canvasWrapper } from '@core/garden/canvas.js';
import Runtime from '@core/helpers/runtime.js';
import Settings from '@core/helpers/settings.js';
import ProductRegistry from '@core/libs/material-list/productsRegistry.js';
import coreReducer from '@core/libs/store/coreReducer.js';
import ReduxStore from '@core/libs/store/reduxStore.js';
import AppStorage from '@core/server/appStorage.js';
import { initI18n } from '@shared/helpers/i18n.js';
import { debounce } from 'lodash-es';

import initMontanaGUI from './legacy/gui/initGUI.js';
import setBodyClass from './legacy/gui/setBodyClass.js';
import { userDataApi } from './libs/server/userDataApi.js';
import montanaReducer from './libs/store/MontanaReducer.js';
import { setBlockUnload } from './libs/store/slices/MontanaGui.slice.js';
import MontanaAPI from './shared/libs/montanaAPI.js';

const askLeaveBeforeUnload = function (event) {
  const showMessage = !event?.target?.activeElement?.classList?.contains('btn') && !ReduxStore.state.gui?.blockUnload;
  ReduxStore.dispatch(setBlockUnload(false));
  return showMessage || undefined;
};

const saveStateBeforeUnload = async () => {
  const currentState = await MontanaAPI.data.get();

  if (currentState?.canvas?.objects?.length < 0) {
    return;
  }

  AppStorage.setItem(currentState);
  AppStorage.migrateOldStorageVariables();
};

const registerEventListeners = () => {
  window.addEventListener(
    'resize.canvasDimension',
    debounce(function () {
      Settings.dimensions = {
        width: window.innerWidth,
        height: window.innerHeight - Settings.dimensionsHeightMod,
      };
    }, 50)
  );

  window.addEventListener('beforeunload', saveStateBeforeUnload);

  // onbeforeunload is not triggered in iOS (Safari + Chrome), we need to
  // call onunload here
  if (Runtime.device.isIOS) {
    window.onunload = () => saveStateBeforeUnload();
  }

  window.onbeforeunload = askLeaveBeforeUnload;
};

// on document ready
const initGarden = async () => {
  window.removeEventListener('DOMContentLoaded', initGarden);

  setBodyClass();
  initI18n({});

  const reducer = {
    ...coreReducer,
    ...montanaReducer,
  };
  ReduxStore.init(reducer, userDataApi.middleware);

  initMontanaGUI();

  // expose store and canvas when run in Cypress
  if (window.Cypress) {
    window.getState = ReduxStore.store.getState;
    window.gardenCanvasWrapper = canvasWrapper;
  }

  registerEventListeners();
  await ProductRegistry.init();
};

const startApp = () => {
  // Check for the origin being valid
  if (window.location.origin !== Settings.baseUrl) {
    return;
  }

  document.getElementById('wrapper-all').style.display = '';
  document.getElementById('wrapper-all').style.opacity = '';

  if (document.readyState !== 'loading') {
    initGarden();
  } else {
    document.addEventListener('DOMContentLoaded', initGarden);
  }
};

startApp();
